import React, { ReactNode } from "react";
import { type Client } from "@/types";
import CustomerInfoModal from "@/components/customer-info";
import { useHasRole } from "@/hooks/useHasRole";

interface ClientDialogProps {
  children?: ReactNode;
  isOpen: boolean;
  onOpenChange: (open: boolean) => void;
  formData: Client;
  saveClient: (client: Client) => void;
  isSubmitting: boolean;
}

const ClientsDialog: React.FC<ClientDialogProps> = ({
  children,
  isOpen,
  onOpenChange,
  formData,
  saveClient,
  isSubmitting,
}) => {
  const { isAdminOrManager } = useHasRole();

  return (
    <>
      {children}
      <CustomerInfoModal
        open={isOpen}
        onOpenChange={onOpenChange}
        onSubmit={(client: Client) => saveClient(client)}
        defaultValues={formData}
        isSubmitting={isSubmitting}
        isClientTab
        isAdminOrManager={isAdminOrManager}
      />
    </>
  );
};

export default ClientsDialog;
